export default function reducer(state = {}, action) {
  switch (action.type) {
    case "WINDOW/CURRENT_SCROLL_POSITION_UPDATED":
      return {
        ...state,
        currentScrollPosition: action.payload.currentScrollPosition
      };

    case "WINDOW/CURRENT_VIEWPORT_WIDTH_UPDATED":
      return {
        ...state,
        currentViewportWidth: action.payload.currentViewportWidth
      };

    default:
      return state;
  }
}

export const getCurrentScrollPosition = state => state?.window?.currentScrollPosition;
export const getCurrentViewportWidth = state => state?.window?.currentViewportWidth;
